import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35aad344"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "account-confirmation",
  class: "view"
}
const _hoisted_2 = { class: "container" }

import { toRefs } from 'vue'

  import AccountConfirmationResend from '@/components/User/AccountConfirmationEmail.vue'
  interface Props {
    action: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    action: null
  },
  setup(__props: any) {

const props = __props as {
    action: string
  }

  
  const { action } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AccountConfirmationResend, { action: _unref(action) }, null, 8, ["action"])
    ])
  ]))
}
}

})